import { Ability } from '@casl/ability';

const perms = []

export default new Ability(perms)